module.exports = __webpack_public_path__ + "assets/img/right_item02.032794a3.png";